import styled from "styled-components";
import { Form } from "formik";

const FONT_STACK = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`;

export const LoginContainer = styled(Form)`
  min-height: calc(100vh - 130px);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${FONT_STACK};

  @media (max-width: 800px) {
    min-height: 100vh;
  }

  @media (min-width: 801px) and (max-width: 1023px) {
    align-items: center;
    min-height: 100vh;
  }
`;

export const DataContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 14px;
  padding: 36px 32px 28px 32px;
  width: 360px;
  background: linear-gradient(180deg, #ffffff 0%, #f3ebfa 100%);
  border: 1.5px solid rgba(76, 4, 140, 0.22);
  border-radius: 12px;
  box-shadow:
    0 1px 2px rgba(76, 4, 140, 0.06),
    0 14px 36px -10px rgba(76, 4, 140, 0.28);
  position: relative;
  overflow: hidden;
  font-family: ${FONT_STACK};
  font-feature-settings: "cv11", "ss01";
  -webkit-font-smoothing: antialiased;
  color: var(--grisOscuro);

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(
      90deg,
      var(--violetaOscuro) 0%,
      var(--violeta) 50%,
      var(--naranja) 100%
    );
  }

  img {
    width: 110px;
    height: auto;
    margin-bottom: 4px;
  }

  @media (max-width: 800px) {
    margin-top: 120px;
    width: 88%;
    max-width: 360px;
  }

  @media (min-width: 801px) and (max-width: 1023px) {
    margin-top: 120px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 5px;
  width: 100%;
  margin: 4px 0;

  span {
    position: absolute;
    color: var(--grisMedio);
    top: 0.85rem;
    left: 1rem;
    pointer-events: none;
    transition: 180ms cubic-bezier(0.4, 0, 0.2, 1);
    font-family: ${FONT_STACK};
    font-size: 0.9rem;
    font-weight: 500;
    letter-spacing: -0.005em;
  }

  #username,
  #password {
    all: unset;
    width: 100%;
    box-sizing: border-box;
    color: var(--grisOscuro);
    padding: 0.85rem 1rem;
    border: 1.5px solid rgba(76, 4, 140, 0.18);
    border-radius: 8px;
    transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
    background-color: white;
    font-family: ${FONT_STACK};
    font-size: 0.92rem;
    font-weight: 500;
    letter-spacing: -0.005em;

    &:hover {
      border-color: rgba(76, 4, 140, 0.32);
    }

    &:focus {
      border-color: var(--violetaOscuro);
      box-shadow: 0 0 0 3px rgba(203, 182, 219, 0.35);
    }

    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 1000px white inset !important;
      -webkit-text-fill-color: var(--grisOscuro) !important;
      transition: background-color 5000s ease-in-out 0s;
    }

    &:is(:focus, :valid) ~ span {
      transform: translateY(-160%) scale(0.78);
      background-color: white;
      padding-inline: 0.4rem;
      color: var(--violetaOscuro);
      font-weight: 600;
    }
  }

  div {
    position: relative;
    --primary: var(--violetaOscuro);
  }
`;

export const InputStyled = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: 1.5px solid rgba(76, 4, 140, 0.18);
  font-family: ${FONT_STACK};
  font-size: 0.9rem;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    border-color: rgba(76, 4, 140, 0.32);
  }

  &:focus {
    border-color: var(--violetaOscuro);
    outline: none;
    box-shadow: 0 0 0 3px rgba(203, 182, 219, 0.35);
  }
`;

export const ErrorStyled = styled.span`
  font-family: ${FONT_STACK};
  font-size: 0.72rem;
  font-weight: 500;
  color: #c62828;
  letter-spacing: -0.005em;
`;

export const VersionTag = styled.small`
  display: block;
  margin-top: 1.25rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: var(--grisMedio);
  opacity: 0.75;
`;
